import React, { useEffect, useState } from "react"
import { Box, Button, TextField, Typography } from "@mui/material"
import DownloadIcon from "@mui/icons-material/Download"
import CustomTable from "../../components/table/Table"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { toast } from "sonner"
import { clearMessage } from "../../redux/Slice/message"
import { setLoading } from "../../redux/Slice/loaderSlice"
import { getB2bLead, updateB2bLead } from "../../redux/Slice/b2bLeadSlice"

const columns = [
  { id: "temp_id", label: "Template No", minWidth: 150, align: "start" },
  { id: "name", label: "Template Name", minWidth: 150, align: "start" },
  { id: "status", label: "Status", minWidth: 150, align: "center" },
  { id: "action", label: "Action", minWidth: 150, align: "center", actionType: [{ edit: true, view: true }] },
]

const LeadInactiveTemplates = () => {
  const [searchTerm, setSearchTerm] = useState("");
  // const [status, setStatus] = useState(false)
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modifiedRows, setModifiedRows] = useState([]);

  const message = useSelector((state) => state.message);
  const { b2bLeads,totalPages } = useSelector((state) => state.b2bLead);
  console.log("b2bLead:",b2bLeads);

  const transformB2bleads = (b2bLeads) => 
    b2bLeads.filter((lead) => lead && lead._id && lead.status === false).map((lead) => ({
      _id:lead._id,
      temp_id:lead.temp_id,
      name:lead.templateName,
      status:lead.status? true:false,
      action:"",
    }));

    useEffect(() => {
      if (Array.isArray(b2bLeads)) {
        const transformedLeads = transformB2bleads(b2bLeads);
        setModifiedRows(transformedLeads);
      }
    }, [b2bLeads]);

  useEffect(() => {
    if (message?.message) {
      toast(message.message)
      dispatch(clearMessage())
    }
  }, [message, dispatch])

  useEffect(() => {
    dispatch(setLoading(true));
    dispatch(getB2bLead({ page: page, limit: rowsPerPage, searchTerm: searchTerm })) 
        .then(() => {
            dispatch(setLoading(false));
        })
        .catch(() => {
            dispatch(setLoading(false));
        });
  }, [dispatch, page, rowsPerPage, searchTerm]);


  const handleStatusChange = (row) => {
    console.log("Row:",row);
    
    const updatedStatus = !row.status;
    const b2bLeadId = row._id;
    dispatch(setLoading(true));

    dispatch(updateB2bLead({l_id:b2bLeadId,formData:{status:updatedStatus}})).unwrap()
    .then(() => {
      const updatedRows = modifiedRows.filter((item) =>
        item._id !== b2bLeadId || updatedStatus === false
      );
      setModifiedRows(updatedRows);
      })
      .catch((error) => {
        console.error("Failed to update status:", error);
        toast.error("Failed to update status. Please try again.");
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  }

  const handleEdit = () => {
    console.log("Yasar");
};

const handleView = (row) => {
  if (row._id) {
    navigate(`/leadtemplate/${row._id}`)
  }else {
    console.log("No lead ID found for this row", row);
  }
};

const handleSearch = (event) => {
  setSearchTerm(event.target.value);
}

  

  return (
    <div className="content">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >

      <Typography variant="h5" sx={{ mb: 3, mt: 3 }}>
        Lead Inactive Templates <Typography component="span">({b2bLeads.length})</Typography>
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <TextField placeholder="Search by Name" value={searchTerm} onChange={handleSearch} fullWidth/>
       
       
      </Box>
      </Box>

            <CustomTable
               columns={columns}
               rows={modifiedRows}
               page={page}
               setPage={setPage}
               rowsPerPage={rowsPerPage}
               setRowsPerPage={setRowsPerPage}
               totalPages={totalPages}
               handleEdit={handleEdit}
               handleView={handleView}
               handleStatusChange={handleStatusChange}
             />
    </div>
  )
}

export default LeadInactiveTemplates
